/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Application ErrorHandler that reports uncaught Angular errors.
 */
import {ErrorHandler, Injectable, Injector} from '@angular/core';

import {AdnLogService} from '../../components/util/adn-log.service';

@Injectable()
export class AngularErrorHandlerService implements ErrorHandler {
  // Resolve AdnLogService lazily on first error so early Angular bootstrap
  // does not force Rollbar to initialize before it is ready.
  private adnLog: AdnLogService;

  constructor(private readonly injector: Injector) {
  }

  handleError(error: any): void {
    try {
      this.adnLog = this.adnLog || this.injector.get(AdnLogService);
      this.adnLog.error(error);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
